export const ENDPOINTS = {
  experienceBulkValidate:
    '/gateway/extranet/:id/experiences/:experienceId/bulk-openings/validate',
  experienceBulkSave:
    '/gateway/extranet/:id/experiences/:experienceId/bulk-openings',
  updateExperienceConfiguration:
    '/gateway/extranet/:id/experiences/:experienceId',
  saveExperienceAddOn: '/gateway/extranet/:id/experiences',
} as const;

export const CORE_QUERY_KEYS = {
  experienceBulkSave: 'extranet-bulk-openings-experiences',
  experience: 'admin-experience',
} as const;
